import { Trans } from '@grafana/i18n';
const Routing = () => <Trans i18nKey="alerting.routing.routing">Routing</Trans>;

export { Routing };
